export default __webpack_public_path__ + "static/julian-f6214aeb9dd75f01f8c61590b09e71a2.jpg";